import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgUnderline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 12" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#17181A"
        d="M3.9 10.168C1.366 10.168.092 8.67.092 6.374V.662h1.162v5.684c0 1.708.924 2.786 2.646 2.786s2.646-1.078 2.646-2.786V.662h1.162V6.36c0 2.324-1.274 3.808-3.808 3.808z"
      />
      <path fill="#D8D8D8" stroke="#17181A" d="M.5 11.5h7v1h-7z" />
    </g>
  </svg>
);
const Memo = memo(SvgUnderline);
export default Memo;
